import React from 'react';
import { IAuditoriaMutacaoVolatilResultado } from '../interfaces/IAuditoriaMutacaoVolatil';
import { TributoAuditoria } from '../interfaces/IAuditoria';

interface Props {
  resultado: IAuditoriaMutacaoVolatilResultado;
  onSelecionar: (tributo: TributoAuditoria) => void;
}

const formatCurrency = (v: number) =>
  v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

const AuditoriaResumoMutacaoVolatil: React.FC<Props> = ({ resultado, onSelecionar }) => {
  const temErro   = resultado.totalErros > 0;
  const temAlerta = resultado.totalAlertas > 0;

  const borderColor = temErro ? '#ef4444' : temAlerta ? '#f59e0b' : '#22c55e';
  const badgeClass  = temErro
    ? 'badge bg-danger'
    : temAlerta
    ? 'badge bg-warning text-dark'
    : 'badge bg-success';
  const badgeLabel  = temErro
    ? `${resultado.totalErros} ERRO(S)`
    : temAlerta
    ? `${resultado.totalAlertas} ALERTA(S)`
    : 'CONCILIADO';

  return (
    <div
      className='auditoria-card'
      style={{ borderLeft: `4px solid ${borderColor}`, cursor: 'pointer' }}
      onClick={() => onSelecionar('AUDITORIA_MUTACAO_VOLATIL')}
    >
      <div className='d-flex justify-content-between align-items-start'>
        <div>
          <h5 className='mb-1'>Mutação Volátil — Imobilizado vs Despesas de Manutenção</h5>
          <p className='text-muted mb-2' style={{ fontSize: '0.85rem' }}>
            Volatilidade entre Ativo Imobilizado (1.02.01.01) e Despesas de Manutenção (3.01.01.06).
            CPC 27 · RIR/2018, Art. 351 · SPED ECD/ECF.
          </p>
        </div>
        <span className={badgeClass}>{badgeLabel}</span>
      </div>

      <div className='row g-2 mt-1'>
        <div className='col-md-3'>
          <div className='p-2 rounded' style={{ backgroundColor: temErro ? '#fef2f2' : temAlerta ? '#fef3c7' : '#f0fdf4' }}>
            <div style={{ fontSize: '0.75rem', color: '#6b7280' }}>Exposição Total</div>
            <div style={{ fontSize: '1rem', fontWeight: 700, color: temErro ? '#991b1b' : temAlerta ? '#92400e' : '#16a34a' }}>
              {formatCurrency(resultado.exposicaoTotalGeral)}
            </div>
          </div>
        </div>
        <div className='col-md-3'>
          <div className='p-2 rounded' style={{ backgroundColor: '#f9fafb' }}>
            <div style={{ fontSize: '0.75rem', color: '#6b7280' }}>Passivo Tributário (34%)</div>
            <div style={{ fontSize: '1rem', fontWeight: 600, color: temErro ? '#991b1b' : temAlerta ? '#92400e' : '#374151' }}>
              {formatCurrency(resultado.passivoTributarioTotal)}
            </div>
          </div>
        </div>
        <div className='col-md-3'>
          <div className='p-2 rounded' style={{ backgroundColor: '#f9fafb' }}>
            <div style={{ fontSize: '0.75rem', color: '#6b7280' }}>Erros + Alertas</div>
            <div style={{ fontSize: '1rem', fontWeight: 600, color: temErro ? '#991b1b' : temAlerta ? '#92400e' : '#374151' }}>
              {resultado.totalErros + resultado.totalAlertas}
            </div>
          </div>
        </div>
        <div className='col-md-3'>
          <div className='p-2 rounded' style={{ backgroundColor: '#f9fafb' }}>
            <div style={{ fontSize: '0.75rem', color: '#6b7280' }}>Fundamentação</div>
            <div style={{ fontSize: '0.9rem', fontWeight: 600, color: '#374151' }}>
              CPC 27 · RIR/2018 Art.351
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuditoriaResumoMutacaoVolatil;
